import React from 'react'
import { Icon } from '../Icon'

export type TInfoBoxProps = {
  message?: React.ReactNode
}

export const InfoBox = ({ message }: TInfoBoxProps): JSX.Element => (
  <div className='bg-warning-50 border-l-warning-200 border-warning-100 shadow-dialog text-surface-black-50 font-body text-body-md leading-default rounded-[4px] border border-l-4'>
    <div className='flex items-center gap-2 pl-5'>
      <div className='bg-warning-200 flex items-center justify-center rounded-full p-2'>
        <Icon name='info' size='md' color='surface-white-50' />
      </div>
      <div className='px-4 py-3'>{message}</div>
    </div>
  </div>
)
